export default __webpack_public_path__ + "static/taper-ba94d1f22df9b5a8a8c1f00781a954bd.png";